export default __webpack_public_path__ + "static/media/rightArrow.a9af6d0c.gif";